import { QuestionClusteringConfiguration } from 'tabs/topQuestions/types/InternalTypes'
import { DEFAULT_CLUSTERING_SENSITIVITY } from 'tabs/topQuestions/constants/ClusteringConstants'
import { PendingRequest, RequestStatus } from 'tabs/topQuestions/types/GenericTypes'
import { FetchClusteringStatusResponse } from 'tabs/topQuestions/types/ApiResponses'
import { UPGRADE_TRAIN_CONFIGURATION } from 'tabs/topQuestions/lib/top_questions/topQuestionsConstnats'
import {
  CLEAR_SELECTED_EXECUTION_ID,
  ClusteringConfigurationAction,
  FETCH_CLUSTERING_STATUS_REQUEST,
  FETCH_CLUSTERING_STATUS_SUCCESS,
  UPDATE_ACTIVE_CLUSTERING_EXECUTION_ID,
} from 'tabs/topQuestions/lib/top_questions_config/clusteringConfigurationTypes'


export type ClusteringConfigurationSliceState = {
  activeClusteringExecutionId?: string
  fetchClusteringStatusRequest: PendingRequest<FetchClusteringStatusResponse>
  clusteringConfiguration: QuestionClusteringConfiguration,
}

const createInitialState = (): ClusteringConfigurationSliceState => {
  return {
    fetchClusteringStatusRequest: { status: RequestStatus.NONE },
    clusteringConfiguration: {
      clusterSensitivity: DEFAULT_CLUSTERING_SENSITIVITY,
    },
  }
}

export const clusteringConfigurationSlice = (state: ClusteringConfigurationSliceState = createInitialState(),
                                             action: ClusteringConfigurationAction): ClusteringConfigurationSliceState => {
  switch (action.type) {
    case UPGRADE_TRAIN_CONFIGURATION:
      return {
        ...state,
        clusteringConfiguration: {
          ...state.clusteringConfiguration,
          ...action.payload,
        },
      }
    case CLEAR_SELECTED_EXECUTION_ID:
      return {
        ...state,
        activeClusteringExecutionId: undefined,
      }
    case FETCH_CLUSTERING_STATUS_REQUEST:
      return {
        ...state,
        fetchClusteringStatusRequest: { status: RequestStatus.PENDING },
      }
    case FETCH_CLUSTERING_STATUS_SUCCESS:
      return {
        ...state,
        fetchClusteringStatusRequest: { status: RequestStatus.RESOLVED, data: action.payload },
        activeClusteringExecutionId: action.payload.clusteringExecutionId,
      }
    case UPDATE_ACTIVE_CLUSTERING_EXECUTION_ID:
      return {
        ...state,
        activeClusteringExecutionId: action.payload,
      }
    default:
      return state
  }
}

